import { Field, useFormik, useFormikContext } from "formik";
import { formatString } from "../helper-components/helper-function";
import { useEffect } from "react";
import ItemsInputField from "../forms/items-input-field";
import InvoiceStatus from "./payment-in-out-status";

const PaymentInOutTable = ({
  page,
  clearDue,
  tableBodyData = [],
  checkedId,
  setCheckedId,
  tableHeading = [],
  disabled = false,
  section = "pit",
}) => {
  const { values, setFieldValue, initialValues } = useFormikContext();

  const prefix = section === "pit" ? "soit" : "poit";

  const validateInput = (inputValue, maxValue) => {
    const numValue = parseFloat(inputValue);
    if (numValue < 0) {
      return 0;
    } else if (numValue > maxValue) {
      return maxValue;
    }
    return numValue;
  };

  function checkboxChecker(e, all) {
    if (all === "all" && checkedId.length === e.length) {
      setCheckedId([]);
    } else if (all === "all") {
      setCheckedId(e);
    } else {
      if (checkedId.includes(e?.target?.id)) {
        const checkedValues = [...checkedId];
        const findIndex = checkedValues.findIndex(
          (item) => item === e.target?.id
        );
        checkedValues.splice(findIndex, 1);
        setCheckedId(checkedValues);
      } else {
        setCheckedId((previous) => {
          return [...previous, e.target.id];
        });
      }
    }
  }
  console.table(tableHeading);
  console.table(tableBodyData);

  useEffect(() => {
    setFieldValue("paymentModeData", initialValues?.paymentModeData);

    if (checkedId.length > 0) {
      setFieldValue("credit_note_amount", creditNoteAmount(values?.invoices));
      setFieldValue("journal_entry", journalEntry(values?.invoices));

      setFieldValue(
        "sumOfAmountEnteredInAllInvoices",
        sumOfAmountEnteredInAllInvoices(values?.invoices)
      );
      setFieldValue(
        "fixedCurrentPayment",
        fixedCurrentPayment(values?.invoices)
      );
      setFieldValue(`${section}_total_amount`, invoiceTotal(values?.invoices));
      setFieldValue(`${section}_cmr_amount_paid`, amtpaid(values?.invoices));
      setFieldValue(`${section}_current_payment`, amtpaid(values?.invoices));
      setFieldValue("balanceAmt", balanceAmt(values?.invoices));

      const difference =
        amtpaid(values?.invoices) -
        (sumOfAmountEnteredInAllInvoices(values?.invoices) +
          parseFloat(creditNoteAmount(values?.invoices)) +
          parseFloat(journalEntry(values?.invoices)));

      //  -
      // parseFloat(values?.[`${section}_open_balance`])

      // if (difference > 0) {
      if (amtpaid(values?.invoices) > 0) {
        setFieldValue([`${section}_add_to_account_amount`], difference);
      } else {
        if (page !== "view") {
          setFieldValue([`${section}_add_to_account_amount`], difference);
        }
      }
      // }
    } else {
      setFieldValue("credit_note_amount", 0);
      setFieldValue("sumOfAmountEnteredInAllInvoices", 0);
      setFieldValue("fixedCurrentPayment", 0);
      setFieldValue(`${section}_total_amount`, 0);
      setFieldValue(`${section}_cmr_amount_paid`, 0);
      setFieldValue(`${section}_current_payment`, 0);
      setFieldValue("balanceAmt", 0);
    }
  }, [checkedId]);

  function handleOnChange(rowIndex, fieldName, correctedValue) {
    setFieldValue("paymentModeData", initialValues?.paymentModeData);

    let UpdatedInvoices = [...(values?.invoices || [])];
    UpdatedInvoices[rowIndex][`${prefix}_total_payment`] = correctedValue;

    setFieldValue(fieldName, correctedValue);
    if (checkedId.length > 0) {
      setFieldValue("credit_note_amount", creditNoteAmount(UpdatedInvoices));
      setFieldValue("journal_entry", journalEntry(UpdatedInvoices));

      setFieldValue(
        "sumOfAmountEnteredInAllInvoices",
        sumOfAmountEnteredInAllInvoices(UpdatedInvoices)
      );
      setFieldValue(
        "fixedCurrentPayment",
        fixedCurrentPayment(UpdatedInvoices)
      );
      setFieldValue(`${section}_total_amount`, invoiceTotal(UpdatedInvoices));
      setFieldValue(`${section}_cmr_amount_paid`, amtpaid(UpdatedInvoices));
      setFieldValue(`${section}_current_payment`, amtpaid(UpdatedInvoices));
      setFieldValue("balanceAmt", balanceAmt(UpdatedInvoices));

      const difference =
        amtpaid(UpdatedInvoices) -
        (sumOfAmountEnteredInAllInvoices(UpdatedInvoices) +
          parseFloat(creditNoteAmount(UpdatedInvoices)) +
          parseFloat(journalEntry(UpdatedInvoices)));
        // - parseFloat(values?.[`${section}_open_balance`])

      if (amtpaid(UpdatedInvoices) > 0) {
        setFieldValue([`${section}_add_to_account_amount`], difference);
      } else {
        if (page !== "view") {
          setFieldValue([`${section}_add_to_account_amount`], difference);
        }
      }
    }
  }

  //calculation functions

  function sumOfAmountEnteredInAllInvoices(invoice) {
    return invoice
      .filter(
        (item) =>
          checkedId?.includes(item?.id) &&
          item?.[`podt_doc_type`] !== "purchase_credit_note" &&
          item?.[`podt_doc_type`] !== "journal_entry"
      )
      .reduce((acc, curr) => {
        return acc + parseFloat(curr?.[`${prefix}_total_payment`]);
      }, 0);
  }

  function fixedCurrentPayment(invoice) {
    return (
      sumOfAmountEnteredInAllInvoices(invoice) +
      creditNoteAmount(invoice) +
      journalEntry(invoice)

      // sumOfAmountEnteredInAllInvoices(invoice) - values?.credit_note_amount
      // -
      // values?.[`${section}_open_balance`]
    );
  }
  function creditNoteAmount(invoice) {
    let key;
    if (prefix === "pit") key = "pdt";
    else key = "podt";
    if (!Array.isArray(invoice) || !checkedId?.length) {
      return 0;
    }
    return invoice
      .filter(
        (item) =>
          checkedId?.includes(item?.id) &&
          item?.[`${key}_doc_type`] === "purchase_credit_note"
      )
      .reduce((acc, curr) => {
        return acc + parseFloat(curr?.[`${prefix}_due_amount`]);
      }, 0);
  }
  function journalEntry(invoice) {
    if (!Array.isArray(invoice) || !checkedId?.length) {
      return 0;
    }
    let key;
    if (prefix === "pit") key = "pdt";
    else key = "podt";
    return invoice
      .filter(
        (item) =>
          checkedId?.includes(item?.id) &&
          item?.[`${key}_doc_type`] === "journal_entry"
      )
      .reduce((acc, curr) => {
        return acc + parseFloat(curr?.[`${prefix}_due_amount`]);
      }, 0);
  }

  // sum of balance due of selected purchase_invoice
  function invoiceTotal(invoice) {
    return invoice
      .filter(
        (item) =>
          checkedId?.includes(item?.id) &&
          item.podt_doc_type !== "purchase_credit_note" &&
          item.podt_doc_type !== "journal_entry"
      )
      .reduce((acc, curr) => {
        return acc + parseFloat(curr?.[`${prefix}_due_amount`]);
      }, 0)
      ?.toFixed(2);
  }
  function balanceAmt(invoice) {
    const totalDue = parseFloat(invoiceTotal(invoice)) || 0;
    const current = parseFloat(sumOfAmountEnteredInAllInvoices(invoice)) || 0;
    return totalDue - current;
  }

  function amtpaid(invoice) {
    // if (
    //   values?.paymentModeData.reduce(
    //     (acc, item) => acc + parseFloat(item?.pmt_total_amount),
    //     0
    //   ) > 0
    // ) {
    //   return values?.paymentModeData.reduce(
    //     (acc, item) => acc + parseFloat(item?.pmt_total_amount),
    //     0
    //   );
    // } else {
    return (
      sumOfAmountEnteredInAllInvoices(invoice) +
      parseFloat(creditNoteAmount(invoice)) +
      parseFloat(journalEntry(invoice))
    );
    // }
  }

  return (
    <div
      className=" border border-[var(--create-table-main-border)] rounded-[8px]  p-[14px] mx-[24px] mb-[14px] "
      style={{
        maxHeight: `calc(100% - 11.5rem)`,
        height: `calc(100% - 11.5rem)`,
      }}
    >
      <div
        className={`tab-container rounded-[8px] h-full ${
          tableBodyData?.length > 0 ? "overflow-auto" : "overflow-hidden"
        } w-full`}
      >
        <table className=" tab-container border-collapse  min-w-full h-auto">
          <thead className="sticky  text-[var(--header-button-bg-color)] text-[length:var(--create-table-header-fs)] top-0 z-10">
            <tr className="bg-[var(--list-table-heading-bg)]">
              <th className={`py-[17.6px] px-3 `}>
                <input
                  disabled={disabled}
                  checked={
                    checkedId?.length ===
                      tableBodyData?.map((item) => item?.id).length &&
                    checkedId.length > 0
                  }
                  onChange={() =>
                    checkboxChecker(
                      tableBodyData.map((item) => item?.id),
                      "all"
                    )
                  }
                  style={{ transform: "scale(1.1)" }}
                  type="checkbox"
                  id="myCheckbox"
                  className="custom-checkbox form-check-input"
                />
              </th>

              {tableHeading
                ?.filter((heading) => heading?.enabled !== false)
                ?.map((heading, index) => (
                  <th
                    style={{ minWidth: `${heading?.minWidth}px` }}
                    key={index}
                    className={` py-[17.6px] px-3`}
                  >
                    <div
                      className="flex items-center gap-2 w-full"
                      style={{
                        justifyContent:
                          heading?.alignment === "right"
                            ? "flex-end"
                            : heading?.alignment === "center"
                            ? "center"
                            : "flex-start",
                      }}
                    >
                      {heading?.label}
                    </div>
                  </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {tableBodyData?.length > 0 ? (
              <>
                {tableBodyData.map((rowData, rowIndex) => (
                  <tr
                    className={`hover:bg-[var(--row-hover-color)] ${
                      rowIndex % 2 !== 0 ? "bg-[var(--row-hover-color)]" : ""
                    }`}
                    key={rowIndex}
                  >
                    <td className="text-[length:var(--create-table-row-font-size)] border-b border-b-[var(--light-border-color)] py-4 px-3  font-[var( --list-table-row-font-weight)]  text-center ">
                      <input
                        disabled={disabled}
                        checked={checkedId.includes(rowData?.id)}
                        id={rowData?.id}
                        onChange={(e) => checkboxChecker(e)}
                        style={{ transform: "scale(1.2)" }}
                        type="checkbox"
                        className="custom-checkbox form-check-input"
                      />
                    </td>

                    {tableHeading
                      ?.filter((heading) => heading?.enabled !== false)
                      ?.map((heading, index) => (
                        <td
                          key={index}
                          style={{
                            minWidth: `${heading?.minWidth}px`,
                            textAlign: `${heading?.alignment}`,
                          }}
                          className={`border-b border-b-[var(--light-border-color)] py-1 px-3 text-[length:var(--create-table-row-font-size)] font-[var( --list-table-row-font-weight)]  whitespace-nowrap cursor-pointer`}
                        >
                          {/* <div
                            // className="flex items-center gap-2 w-full"
                            style={{
                              justifyContent:
                                heading?.alignment === "right"
                                  ? "flex-end"
                                  : heading?.alignment === "center"
                                  ? "center"
                                  : "flex-start",
                            }}
                          > */}
                          {console.log(
                            heading.value === `${prefix}_status`,
                            heading.value ? rowData[heading.value] : 0
                          )}
                          {heading.value === `${prefix}_total_payment` ? (
                            <Field
                              name={`invoices[${rowIndex}].${prefix}_total_payment`}
                            >
                              {({ field, form }) => (
                                <input
                                  disabled={
                                    disabled ||
                                    rowData?.podt_doc_type ===
                                      "purchase_credit_note"
                                  }
                                  {...field}
                                  onChange={(e) => {
                                    const inputValue = e.target.value;
                                    const fieldName = `invoices[${rowIndex}].${prefix}_total_payment`;
                                    const maxValue =
                                      parseFloat(
                                        rowData[`${prefix}_due_amount`]
                                      ).toFixed(2) || 0;
                                    const correctedValue = validateInput(
                                      inputValue,
                                      maxValue
                                    );
                                    handleOnChange(
                                      rowIndex,
                                      fieldName,
                                      correctedValue
                                    );
                                  }}
                                  onBlur={(e) => {
                                    const inputValue = e.target.value;
                                    const fieldName = `invoices[${rowIndex}].${prefix}_total_payment`;

                                    if (
                                      inputValue === "" ||
                                      inputValue === null ||
                                      inputValue === undefined ||
                                      isNaN(inputValue)
                                    ) {
                                      handleOnChange(
                                        rowIndex,
                                        fieldName,
                                        (0).toFixed(2)
                                      );
                                      return;
                                    }
                                  }}
                                  value={
                                    values?.invoices?.[rowIndex]?.[
                                      `${prefix}_total_payment`
                                    ] ?? ""
                                  }
                                  type="number"
                                  min="0"
                                  max={
                                    parseFloat(
                                      rowData[`${prefix}_total_payment`]
                                    ).toFixed(2) || 0
                                  }
                                  className={`text-[length:var(--create-table-row-font-size)] text-value-color placeholder:text-placeholder-color ps-2 max-w-[7rem] min-w-[7rem] font-[var(--list-table-row-font-weight)] py-2   focus_outline__none focus:border-primary focus:border  input-field-no-spin-buttons`}
                                />
                              )}
                            </Field>
                          ) : heading.value === `${prefix}_status` ? (
                            <InvoiceStatus status={rowData[heading.value]} />
                          ) : heading.lable === "Document Type" ? (
                            formatString(rowData[heading.value])
                          ) : (
                            rowData[heading.value]
                          )}
                          {/* </div> */}
                        </td>
                      ))}
                  </tr>
                ))}
              </>
            ) : (
              <tr
                style={{
                  height: "20rem",
                }}
              ></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentInOutTable;
